import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    twitterText: String,
    url: String,
    kakaoImageUrl: String,
    kakaoDescription: String,
    kakaoTitle: String,
    kakaoApiKey: String,
  };
  static targets = ['kakao'];

  initialize() {
    this.isKakaoInitialized = false;
  }

  connect() {
    this.isKakaoInitialized = false;
    if (window.Kakao) {
      try {
        if (!window.Kakao.isInitialized()) {
          window.Kakao.init(this.kakaoApiKeyValue);
        }

        this.isKakaoInitialized = true;
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log('window.Kakao가 없습니다');
    }

    if (this.kakaoTarget) {
      if (!this.isKakaoInitialized) {
        this.kakaoTarget.classList.add('hidden');
      } else {
        this.kakaoTarget.classList.remove('hidden');
      }
    }
  }

  disconnect() {
    this.isKakaoInitialized = false;
  }

  twitter(event) {
    window.open(
      'https://twitter.com/intent/tweet?text=' +
        encodeURIComponent(this.twitterTextValue) +
        '&url=' +
        encodeURIComponent(this.urlValue),
    );
  }

  facebook(event) {
    window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.urlValue));
  }

  kakao(event) {
    if (!this.isKakaoInitialized) {
      window.$sendAlert('카카오톡에 공유할 수 없습니다.');
    }
    try {
      const content = {
        title: this.kakaoTitleValue,
        description: this.kakaoDescriptionValue,
        imageUrl: this.kakaoImageUrlValue,
        link: {
          mobileWebUrl: this.urlValue,
          webUrl: this.urlValue,
        },
      };

      Kakao.Link.sendDefault({
        objectType: 'feed',
        content,
      });
    } catch (error) {
      console.error(error);
    }
  }
}
